import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState({});

    const toggleMobileMenu = () => {
        setMobileOpen(!mobileOpen);
    };

    const toggleSubmenu = (index) => {
        setSubmenuOpen((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    return (
        <header className="nav-header header-layout3">
            {/* Header top */}
            <div className="header-three-top-area">
                <div className="container">
                    <div className="header-top-content v2">
                        <ul className="contact-info">
                            <li>
                                <i className="my-icon icon-massage"></i>
                                <p className="para">Pochta: info@mediasavodxonlik.uz</p>
                            </li>
                        </ul>
                        <div className="follow-us-link">
                            <p className="para">Tarmoqlar: </p>
                            <div className="follow-icon"><a href="#"><i className="my-icon icon-facebook"></i></a></div>
                            <div className="follow-icon"><a href="#"><i className="fab fa-telegram"></i></a></div>
                            <div className="follow-icon"><a href="#"><i className="my-icon icon-instagram"></i></a></div>
                            <div className="follow-icon"><a href="#"><i className="my-icon icon-youtube"></i></a></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Desktop menu */}
            <div className="sticky-wrapper">
                <div className="menu-area">
                    <div className="container-xxl">
                        <div className="menu-area-content">
                            <div className="row align-items-center justify-content-between">
                                {/* Logo */}
                                <div className="col-auto">
                                    <div className="header-logo">
                                        <Link to="/"><img src="/assets/images/logo.png" alt="Mediasavodxonlik" /></Link>
                                    </div>
                                </div>

                                {/* Desktop nav */}
                                <div className="col-auto">
                                    <nav className="main-menu d-none d-lg-inline-block">
                                        <ul>
                                            <li><Link to="/">Bosh sahifa</Link></li>
                                            <li><Link to="/videos">Video darslar</Link></li>
                                            <li className="menu-item-has-children">
                                                <a href="#" onClick={() => toggleSubmenu("mashgulotlar")}>Mashg'ulotlar</a>
                                                <ul className={`sub-menu ${submenuOpen["mashgulotlar"] ? "body-visible" : ""}`}>
                                                    <li><Link to="/maruza">Ma'ruza</Link></li>
                                                    <li><Link to="/seminar">Seminar</Link></li>
                                                </ul>
                                            </li>
                                            <li><Link to="/about">Loyiha haqida</Link></li>
                                        </ul>
                                    </nav>
                                </div>

                                {/* Right content */}
                                <div className="col-auto">
                                    <div className="menu-area-right-content">
                                        <div className="search-option-box">
                                            <input type="text" placeholder="Qidiruv..." />
                                            <div className="search">
                                                <i className="my-icon icon-search"></i>
                                            </div>
                                            <i className="fa-solid fa-x close-icon"></i>
                                        </div>
                                        <div className="all-btn">
                                            <Link to="/videos" className="btn-p v1 btn-blue rounded icon-v1">
                                                Boshlash
                                            </Link>
                                        </div>
                                    </div>

                                    {/* Mobile toggle button */}
                                    <div className="navbar-right d-inline-flex d-lg-none">
                                        <button type="button" className="menu-toggle" onClick={toggleMobileMenu}>
                                            <i className="my-icon icon-all"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile menu */}
            <div className={`mobile-menu-wrapper ${mobileOpen ? "body-visible" : ""}`}>
                <div className="mobile-menu-area text-center">
                    <button className="menu-toggle" onClick={toggleMobileMenu}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                    <div className="mobile-logo">
                        <Link to="/"><img src="/assets/images/logo.png" alt="Mediasavodxonlik" /></Link>
                    </div>
                    <div className="mobile-menu">
                        <ul>
                            <li><Link to="/">Bosh sahifa</Link></li>
                            <li><Link to="/videos">Video darslar</Link></li>
                            <li className="menu-item-has-children">
                                <a href="#" onClick={() => toggleSubmenu("mashgulotlar")}>Mashg'ulotlar</a>
                                <ul className={`sub-menu ${submenuOpen["mashgulotlar"] ? "body-visible" : ""}`}>
                                    <li><Link to="/maruza">Ma'ruza</Link></li>
                                    <li><Link to="/seminar">Seminar</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/about">Loyiha haqida</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;